import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <main className="grid min-h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="font-display text-7xl font-extrabold italic text-signal-500 sm:text-9xl">404</p>
          <h1 className="mt-4 font-display text-3xl font-bold uppercase tracking-tight text-ink-100 sm:text-5xl">{t('not-found-title')}</h1>
          <p className="mt-6 text-base leading-7 text-ink-300">{t('not-found-text')}</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link to="/" className="rounded-full bg-signal-500 px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-glow transition-colors hover:bg-signal-400">
              {t('not-found-fallback-link')}
            </Link>
            <Link to="/contacts" className="text-sm font-semibold uppercase tracking-wide text-ink-200 transition-colors hover:text-signal-400">
              {t('not-found-contacts-link')} <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </div>
      </main>
    </>
  )
}
